import React from 'react';
import { PageLoader } from '@starrez/starryui';

export const ModuleLoading = () => {
    return <PageLoader Caption="Loading..." />;
};
